var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.type === "select"
    ? _c(
        "div",
        {
          staticClass: "filter-chip-container",
          class: {
            "chip-container--removable": _vm.removable,
            "chip-container--clearable": _vm.clearable,
          },
          attrs: { "data-filter-field": _vm.dataFilterField },
        },
        [
          _vm.operatorSelectable
            ? _c("SelectOperatorCompositeFilterChip", {
                ref: "popoverSelect",
                attrs: {
                  value: _vm.value,
                  "value-text": _vm.valueText,
                  options: _vm.options,
                  "filter-name": _vm.filterName,
                  icon: _vm.icon,
                  "enable-search": _vm.enableSearch,
                  removable: _vm.removable,
                  clearable: _vm.isClearable,
                  "button-class":
                    _vm.chipClass +
                    (_vm.removable ? " chip--removable" : "") +
                    (_vm.hasValue ? " chip--has-value" : ""),
                  "has-value": _vm.hasValue,
                  "data-filter-field": _vm.dataFilterField,
                  operator: _vm.operator,
                },
                on: {
                  input: _vm.onInput,
                  change: _vm.onChange,
                  "operator-change": _vm.onSelectCompositeOperatorChange,
                  "search-input": _vm.onSearchInput,
                  "remove-click": _vm.onRemove,
                  "clear-click": _vm.onClear,
                  "popover-change": _vm.onPopoverChange,
                },
              })
            : _c("MinimalPopoverSelect", {
                key: "mps-" + String(_vm.multiple),
                ref: "popoverSelect",
                attrs: {
                  value: _vm.value,
                  valueText: _vm.valueText,
                  options: _vm.options,
                  multiple: _vm.multiple,
                  "filter-name": _vm.filterName,
                  "show-icon": true,
                  "enable-search": _vm.enableSearch,
                  "show-dropdown-arrow": false,
                  "button-class":
                    _vm.chipClass +
                    (_vm.removable ? " chip--removable" : "") +
                    (_vm.hasValue ? " chip--has-value" : ""),
                  "popover-class": "filter-select-popover",
                  "check-icon": "done",
                  "default-icon": _vm.icon,
                  removable: _vm.removable,
                  clearable: _vm.isClearable,
                },
                on: {
                  input: _vm.onInput,
                  change: _vm.onChange,
                  "search-input": _vm.onSearchInput,
                  "remove-click": _vm.onRemove,
                  "clear-click": _vm.onClear,
                },
              }),
        ],
        1
      )
    : _vm.type === "text"
    ? _c(
        "div",
        {
          staticClass: "filter-chip-container",
          class: {
            "chip-container--removable": _vm.removable,
            "chip-container--clearable": _vm.clearable,
          },
          attrs: { "data-filter-field": _vm.dataFilterField },
        },
        [
          _c(
            "CustomPopover",
            {
              ref: "customPopover",
              attrs: {
                icon: _vm.icon,
                label: _vm.getLabel(),
                "show-dropdown-arrow": false,
                "button-class":
                  _vm.chipClass +
                  (_vm.removable ? " chip--removable" : "") +
                  (_vm.hasValue ? " chip--has-value" : ""),
                "popover-class": "filter-select-popover",
                "show-form-footer": true,
                removable: _vm.removable,
                clearable: _vm.isClearable,
              },
              on: {
                "popover-change": _vm.onPopoverChange,
                clear: _vm.onPopoverClear,
                apply: _vm.onPopoverApply,
                "remove-click": _vm.onRemove,
                "clear-click": _vm.onClear,
              },
            },
            [
              _c("template", { slot: "content" }, [
                _vm.operatorSelectable
                  ? _c("div", { staticClass: "operator-section" }, [
                      _c("label", { staticClass: "operator-label" }, [
                        _vm._v(_vm._s(_vm.$t("chat.filterChip.operator"))),
                      ]),
                      _vm._v(" "),
                      _c(
                        "select",
                        {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.currentOperator,
                              expression: "currentOperator",
                            },
                          ],
                          staticClass: "operator-select",
                          on: {
                            change: [
                              function ($event) {
                                var $$selectedVal = Array.prototype.filter
                                  .call($event.target.options, function (o) {
                                    return o.selected
                                  })
                                  .map(function (o) {
                                    var val = "_value" in o ? o._value : o.value
                                    return val
                                  })
                                _vm.currentOperator = $event.target.multiple
                                  ? $$selectedVal
                                  : $$selectedVal[0]
                              },
                              _vm.onOperatorChange,
                            ],
                          },
                        },
                        _vm._l(_vm.textOperatorOptions, function (option) {
                          return _c(
                            "option",
                            {
                              key: option.value,
                              domProps: { value: option.value },
                            },
                            [
                              _vm._v(
                                "\n                        " +
                                  _vm._s(option.label) +
                                  "\n                    "
                              ),
                            ]
                          )
                        }),
                        0
                      ),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c("div", { staticClass: "input-container" }, [
                  _c("input", {
                    staticClass: "popover-input",
                    attrs: {
                      type: "text",
                      placeholder: _vm.$t("chat.filterChip.enterText"),
                    },
                    domProps: { value: _vm.value },
                    on: { input: _vm.onInputChange, blur: _vm.onInputBlur },
                  }),
                ]),
              ]),
            ],
            2
          ),
        ],
        1
      )
    : _vm.type === "number"
    ? _c(
        "div",
        {
          staticClass: "filter-chip-container",
          class: {
            "chip-container--removable": _vm.removable,
            "chip-container--clearable": _vm.clearable,
          },
          attrs: { "data-filter-field": _vm.dataFilterField },
        },
        [
          _c(
            "CustomPopover",
            {
              attrs: {
                icon: _vm.icon,
                label: _vm.getLabel(),
                "show-dropdown-arrow": false,
                "button-class":
                  _vm.chipClass +
                  (_vm.removable ? " chip--removable" : "") +
                  (_vm.hasValue ? " chip--has-value" : ""),
                "show-form-footer": true,
                removable: _vm.removable,
                clearable: _vm.isClearable,
              },
              on: {
                "popover-change": _vm.onPopoverChange,
                clear: _vm.onPopoverClear,
                apply: _vm.onPopoverApply,
                "remove-click": _vm.onRemove,
                "clear-click": _vm.onClear,
              },
            },
            [
              _c("template", { slot: "content" }, [
                _vm.operatorSelectable
                  ? _c("div", { staticClass: "operator-section" }, [
                      _c("label", { staticClass: "operator-label" }, [
                        _vm._v(_vm._s(_vm.$t("chat.filterChip.operator"))),
                      ]),
                      _vm._v(" "),
                      _c(
                        "select",
                        {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.currentOperator,
                              expression: "currentOperator",
                            },
                          ],
                          staticClass: "operator-select",
                          on: {
                            change: [
                              function ($event) {
                                var $$selectedVal = Array.prototype.filter
                                  .call($event.target.options, function (o) {
                                    return o.selected
                                  })
                                  .map(function (o) {
                                    var val = "_value" in o ? o._value : o.value
                                    return val
                                  })
                                _vm.currentOperator = $event.target.multiple
                                  ? $$selectedVal
                                  : $$selectedVal[0]
                              },
                              _vm.onOperatorChange,
                            ],
                          },
                        },
                        _vm._l(_vm.numberOperatorOptions, function (option) {
                          return _c(
                            "option",
                            {
                              key: option.value,
                              domProps: { value: option.value },
                            },
                            [
                              _vm._v(
                                "\n                        " +
                                  _vm._s(option.label) +
                                  "\n                    "
                              ),
                            ]
                          )
                        }),
                        0
                      ),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c("div", { staticClass: "input-container" }, [
                  _c("input", {
                    staticClass: "popover-input",
                    attrs: {
                      type: "number",
                      placeholder: _vm.$t("chat.filterChip.enterNumber"),
                    },
                    domProps: { value: _vm.value },
                    on: { input: _vm.onInputChange, blur: _vm.onInputBlur },
                  }),
                ]),
              ]),
            ],
            2
          ),
        ],
        1
      )
    : _vm.type === "date"
    ? _c(
        "div",
        {
          staticClass: "filter-chip-container",
          class: {
            "chip-container--removable": _vm.removable,
            "chip-container--clearable": _vm.clearable,
          },
          attrs: { "data-filter-field": _vm.dataFilterField },
        },
        [
          _c(
            "CustomPopover",
            {
              ref: "customPopover",
              attrs: {
                icon: _vm.icon,
                label: _vm.getLabel(),
                "show-dropdown-arrow": false,
                "button-class":
                  _vm.chipClass +
                  (_vm.removable ? " chip--removable" : "") +
                  (_vm.hasValue ? " chip--has-value" : ""),
                "show-form-footer": true,
                removable: _vm.removable,
                clearable: _vm.isClearable,
              },
              on: {
                "popover-change": _vm.onPopoverChange,
                clear: _vm.onPopoverClear,
                apply: _vm.onPopoverApply,
                "remove-click": _vm.onRemove,
                "clear-click": _vm.onClear,
              },
            },
            [
              _c("template", { slot: "content" }, [
                _vm.operatorSelectable
                  ? _c("div", { staticClass: "operator-section" }, [
                      _c("label", { staticClass: "operator-label" }, [
                        _vm._v(_vm._s(_vm.$t("chat.filterChip.operator"))),
                      ]),
                      _vm._v(" "),
                      _c(
                        "select",
                        {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.currentOperator,
                              expression: "currentOperator",
                            },
                          ],
                          staticClass: "operator-select",
                          on: {
                            change: [
                              function ($event) {
                                var $$selectedVal = Array.prototype.filter
                                  .call($event.target.options, function (o) {
                                    return o.selected
                                  })
                                  .map(function (o) {
                                    var val = "_value" in o ? o._value : o.value
                                    return val
                                  })
                                _vm.currentOperator = $event.target.multiple
                                  ? $$selectedVal
                                  : $$selectedVal[0]
                              },
                              _vm.onOperatorChange,
                            ],
                          },
                        },
                        _vm._l(_vm.dateOperatorOptions, function (option) {
                          return _c(
                            "option",
                            {
                              key: option.value,
                              domProps: { value: option.value },
                            },
                            [
                              _vm._v(
                                "\n                        " +
                                  _vm._s(option.label) +
                                  "\n                    "
                              ),
                            ]
                          )
                        }),
                        0
                      ),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.currentOperator === "between"
                  ? _c("div", { staticClass: "input-container" }, [
                      _c("div", { staticClass: "date-preset-container" }, [
                        _c(
                          "div",
                          { staticClass: "date-preset-list" },
                          _vm._l(_vm.datePresetOptions, function (preset) {
                            return _c(
                              "div",
                              {
                                key: preset.value,
                                staticClass: "date-preset-item",
                                class: {
                                  "date-preset-item--active":
                                    _vm.selectedDatePreset === preset.value,
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.onDatePresetSelect(preset.value)
                                  },
                                },
                              },
                              [
                                _vm._v(
                                  "\n                            " +
                                    _vm._s(preset.label) +
                                    "\n                        "
                                ),
                              ]
                            )
                          }),
                          0
                        ),
                      ]),
                      _vm._v(" "),
                      _vm.selectedDatePreset === "custom"
                        ? _c(
                            "div",
                            { staticClass: "date-custom-container" },
                            [
                              _c("a-range-picker", {
                                staticClass: "popover-range-picker",
                                attrs: {
                                  value: _vm.customDateRange,
                                  format: "YYYY-MM-DD",
                                },
                                on: { change: _vm.onDateRangeChange },
                              }),
                            ],
                            1
                          )
                        : _vm._e(),
                    ])
                  : _c(
                      "div",
                      { staticClass: "input-container" },
                      [
                        _c("a-date-picker", {
                          staticClass: "popover-date-picker",
                          attrs: {
                            value: _vm.singleDateValue,
                            format: "YYYY-MM-DD",
                          },
                          on: { change: _vm.onSingleDateChange },
                        }),
                      ],
                      1
                    ),
              ]),
            ],
            2
          ),
        ],
        1
      )
    : _vm.type === "composite"
    ? _c(
        "div",
        {
          staticClass: "filter-chip-container",
          class: {
            "chip-container--removable": _vm.removable,
            "chip-container--clearable": _vm.clearable,
          },
          attrs: { "data-filter-field": _vm.dataFilterField },
        },
        [
          _c(
            "CustomPopover",
            {
              ref: "customPopover",
              attrs: {
                icon: _vm.icon,
                label: _vm.getCompositeLabel(),
                "show-dropdown-arrow": false,
                "button-class":
                  _vm.chipClass +
                  (_vm.removable ? " chip--removable" : "") +
                  (_vm.hasValue ? " chip--has-value" : ""),
                "show-form-footer": true,
                removable: _vm.removable,
                clearable: _vm.isClearable,
              },
              on: {
                "popover-change": _vm.onPopoverChange,
                clear: _vm.onPopoverClear,
                apply: _vm.onPopoverApply,
                "remove-click": _vm.onRemove,
                "clear-click": _vm.onClear,
              },
            },
            [
              _c("template", { slot: "content" }, [
                _c("div", { staticClass: "composite-container" }, [
                  _c("div", { staticClass: "composite-field" }, [
                    _c("label", { staticClass: "composite-label" }, [
                      _vm._v(
                        _vm._s(
                          _vm.compositeSelectLabel ||
                            _vm.$t("chat.filterChip.type")
                        ) + ":"
                      ),
                    ]),
                    _vm._v(" "),
                    _c(
                      "select",
                      {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.compositeSelectValue,
                            expression: "compositeSelectValue",
                          },
                        ],
                        staticClass: "composite-select",
                        on: {
                          change: function ($event) {
                            var $$selectedVal = Array.prototype.filter
                              .call($event.target.options, function (o) {
                                return o.selected
                              })
                              .map(function (o) {
                                var val = "_value" in o ? o._value : o.value
                                return val
                              })
                            _vm.compositeSelectValue = $event.target.multiple
                              ? $$selectedVal
                              : $$selectedVal[0]
                          },
                        },
                      },
                      _vm._l(_vm.options, function (option) {
                        return _c(
                          "option",
                          {
                            key: option.value,
                            domProps: { value: option.value },
                          },
                          [
                            _vm._v(
                              "\n                            " +
                                _vm._s(option.label) +
                                "\n                        "
                            ),
                          ]
                        )
                      }),
                      0
                    ),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "composite-field" }, [
                    _c("label", { staticClass: "composite-label" }, [
                      _vm._v(
                        _vm._s(
                          _vm.compositeInputLabel ||
                            _vm.$t("chat.filterChip.value")
                        ) + ":"
                      ),
                    ]),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.compositeInputValue,
                          expression: "compositeInputValue",
                        },
                      ],
                      staticClass: "composite-input",
                      attrs: {
                        type: "text",
                        placeholder:
                          _vm.compositeInputPlaceholder ||
                          _vm.$t("chat.filterChip.enterValue"),
                      },
                      domProps: { value: _vm.compositeInputValue },
                      on: {
                        input: function ($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.compositeInputValue = $event.target.value
                        },
                      },
                    }),
                  ]),
                ]),
              ]),
            ],
            2
          ),
        ],
        1
      )
    : _vm.type === "broadcast-composite"
    ? _c("BroadcastCompositeFilterChip", {
        ref: "broadcastComposite",
        attrs: {
          value: _vm.value,
          "filter-name": _vm.filterName,
          icon: _vm.icon,
          removable: _vm.removable,
          clearable: _vm.clearable,
          "data-filter-field": _vm.dataFilterField,
        },
        on: { change: _vm.onChange, remove: _vm.onRemove },
      })
    : _vm.type === "meta-referral-composite"
    ? _c("MetaReferralCompositeFilterChip", {
        ref: "metaReferralComposite",
        attrs: {
          value: _vm.value,
          "filter-name": _vm.filterName,
          icon: _vm.icon,
          removable: _vm.removable,
          clearable: _vm.clearable,
          "data-filter-field": _vm.dataFilterField,
        },
        on: { change: _vm.onChange, remove: _vm.onRemove },
      })
    : _vm.type === "add"
    ? _c(
        "div",
        [
          _c("MinimalPopoverSelect", {
            ref: "popoverSelect",
            attrs: {
              value: _vm.value,
              options: _vm.options,
              multiple: _vm.multiple,
              "enable-search": _vm.enableSearch,
              "show-icon": false,
              "show-dropdown-arrow": false,
              "check-icon": "done",
            },
            on: {
              input: _vm.onInput,
              change: _vm.onChange,
              "search-input": _vm.onSearchInput,
            },
            scopedSlots: _vm._u([
              {
                key: "trigger",
                fn: function () {
                  return [
                    _c("div", { staticClass: "chip filter-chip chip--add" }, [
                      _c("i", { staticClass: "material-icons" }, [
                        _vm._v("add"),
                      ]),
                      _vm._v(" "),
                      _c("span", [
                        _vm._v(
                          _vm._s(
                            _vm.label || _vm.$t("chat.filterChip.addFilter")
                          )
                        ),
                      ]),
                    ]),
                  ]
                },
                proxy: true,
              },
            ]),
          }),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }